import React, { Fragment, useMemo } from 'react';
import Head from 'next/head';
import getSEOSchema from '~/cards/components/CardListing/Breadcrumbs/helper';

type Items = {
  to: string;
  label: string;
  schemaTo: string;
};

type SEOSchemaProps = {
  items: Items[];
  currentItem: string;
};

const SEOSchema = ({ items, currentItem }: SEOSchemaProps): JSX.Element => {
  const stringifiedContent = useMemo(() => JSON.stringify(getSEOSchema(items, currentItem)), [
    items,
    currentItem,
  ]);
  return (
    <Fragment>
      <Head>
        <script
          type="application/ld+json"
          key="cardPlpBreadcrumbSchema"
          dangerouslySetInnerHTML={{ __html: stringifiedContent }}
        />
      </Head>
    </Fragment>
  );
};

export default SEOSchema;
